import {
  Component,
  DestroyRef,
  ElementRef,
  computed,
  inject,
  signal,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';

import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SkeletonModule } from 'primeng/skeleton';
import { DropdownModule } from 'primeng/dropdown';
// import { InputSwitchMoleculeComponent } from 'src/app/components/input-switch-molecule/input-switch-molecule.component';
import { EditorModule } from 'primeng/editor';

import {
  FormFieldMoleculeComponent,
  LabelAtomComponent,
} from '@ls-commons/components';

import { HttpClient } from '@angular/common/http';
import { CheckboxModule } from 'primeng/checkbox';
import { ModalService } from '@ls-commons/utils/modals';
import { CalendarModule } from 'primeng/calendar';
import { FieldsetModule } from 'primeng/fieldset';
import { DividerModule } from 'primeng/divider';
import jsPDF from 'jspdf';
import { format } from 'date-fns/format';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { NgIf } from '@angular/common';
// import {
//   symptomsValidator,
//   divingWithValidator,
//   divingTypeValidator,
// } from './checkboxes-required.validator';

@Component({
  selector: 'app-oceanografia-form',
  standalone: true,
  imports: [
    FormFieldMoleculeComponent,
    ButtonModule,
    SelectButtonModule,
    LabelAtomComponent,
    ReactiveFormsModule,
    SkeletonModule,
    CheckboxModule,
    // InputSwitchMoleculeComponent,
    DropdownModule,
    EditorModule,
    CalendarModule,
    FieldsetModule,
    DividerModule,
    ToggleButtonModule,
    NgIf,
  ],
  templateUrl: './oceanografia-form.component.html',
  styleUrl: './oceanografia-form.component.scss',
})
export class OceanografiaFormComponent {
  oceanografiaForm!: FormGroup;
  modalService = inject(ModalService);
  destroyRef = inject(DestroyRef);
  http = inject(HttpClient);
  // utilsService = inject(UtilsService);
  defaultDate = new Date();
  // price: number = 42.99;

  private _isLoading = signal<boolean>(true);
  public isLoading = computed(() => this._isLoading());

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    readonly fb: FormBuilder,
    private el: ElementRef
  ) {
    this.oceanografiaForm = this.fb.group(
      {
        name: ['', Validators.required],
        nif: ['', Validators.required],
        nombre_director: ['', Validators.required],

        calle: ['', Validators.required],
        numero: ['', Validators.required],
        piso: ['', Validators.required],
        cp: ['', Validators.required],
        ciudad: ['', Validators.required],
        telefono: ['', Validators.required],
        email: ['', [Validators.required, Validators.email]], //

        comun: [''],

        firma: ['', Validators.required],
        fecha: [new Date(), Validators.required],
        cargo_empresa: ['', Validators.required],
        fecha_inicio_seguro: [new Date(), Validators.required],
      },
      {
        validators: [
          // symptomsValidator(),
          // divingWithValidator(),
          // divingTypeValidator(),
        ],
      }
    );
  }

  closeDialog() {
    this.ref.close(false);
  }

  sendForm() {
    const form = this.oceanografiaForm.getRawValue();
    // const observable$ =
    // this.oceanografiaForm.controls['diving_with'].markAsTouched();
    this.oceanografiaForm.markAllAsTouched();

    console.log('oceanografiaForm', this.oceanografiaForm.controls);
    console.log('form_values', form);

    if (this.oceanografiaForm.valid) {
      const page = document.querySelector('.page') as HTMLElement;
      const oceanografiaFormData = this.oceanografiaForm.getRawValue();
      const { nif, fecha } = oceanografiaFormData;

      const filename = `${nif} ${format(fecha || new Date(), 'Y-m-d')}.pdf`;
      const doc = new jsPDF();
      doc.setProperties({
        title: filename,
      });

      doc.html(page, {
        callback: doc => {
          const pdfBlob = doc.output('blob');
          const reader = new FileReader();
          reader.readAsArrayBuffer(pdfBlob);
          reader.onloadend = () => {
            const pdfArrayBuffer = reader.result as ArrayBuffer;
            const url = `pdf/generate-oceanografia-pdf?name=${nif}&accident_date=${fecha}`;
            this.http
              .post(url, pdfArrayBuffer, {
                responseType: 'text',
                headers: { 'Content-Type': 'application/pdf' },
              })
              .subscribe({
                next: () => {
                  this.modalService.showSuccessMessage(
                    `Su solicitud ha sido enviada correctamente.`
                  );

                  this.ref.close(true);
                },
                error: () => {
                  this.modalService.showErrorMessage(
                    `El proceso no se ha podido completar.`
                  );
                },
              });
          };
        },
        margin: 5,
        // x: 10,
        y: 5,
        width: 200,
        windowWidth: 900,
      });
    } else {
      this.modalService.showErrorMessage(
        `Es necesario rellenar todos los campos obligatorios`
      );
    }

    if (this.oceanografiaForm.valid) {
      // Lógica para enviar el formulario
      console.log('Formulario enviado', this.oceanografiaForm.value);
    } else {
      console.log('Formulario no válido');
    }
  }

  async oceanografiaFormToPDF() {
    this.oceanografiaForm.markAllAsTouched();

    // const order = this.orders.find(order => order.id == orderId);
    // await this.orderLineService
    //   .getElementsByOrderId(orderId)
    //   .subscribe(async (response: OrderLine[]) => {
    // generarMiPDF(order, response);

    // const ref = await this.dialogService.open(OceanografiaFormComponent, {
    //   dismissableMask: true,
    //   // closable: false,
    //   // closeOnEscape: false,
    //   header: 'Exportar a PDF',
    //   data: {
    //     // order,
    //     // orderLines: await response,
    //     autoExport: true,
    //   },
    //   width: '1000px',
    // });
    // });

    if (this.oceanografiaForm.valid) {
      const page = document.querySelector('.page') as HTMLElement;
      const oceanografiaFormData = this.oceanografiaForm.getRawValue();
      const { name, accident_date } = oceanografiaFormData;

      const filename = `${name} ${format(
        accident_date || new Date(),
        'Y-m-d'
      )}.pdf`;
      const doc = new jsPDF();
      doc.setProperties({
        title: filename,
      });

      doc.html(page, {
        callback: doc => {
          doc.save(filename);

          this.modalService.showSuccessMessage(
            `Formulario enviado correctamente`
          );

          // const pdfBlob = doc.output('blob');
          // const reader = new FileReader();
          // reader.readAsArrayBuffer(pdfBlob);
          // reader.onloadend = () => {
          //   const pdfArrayBuffer = reader.result as ArrayBuffer;
          //   const url = `pdf/generate-pdf?codigo=${codigo}&df_titular=${df_titular}`;
          //   this.http
          //     .post(url, pdfArrayBuffer, {
          //       responseType: 'text',
          //       headers: { 'Content-Type': 'application/pdf' },
          //     })
          //     .subscribe(
          //       response => {
          //         const pdfUrl = response;
          //         window.open(pdfUrl, '_blank');
          //         this.ref.close(true);
          //       },
          //       error => {
          //         console.error('Error generating PDF:', error);
          //       }
          //     );
          // };
        },
        margin: 5,
        // x: 10,
        y: 5,
        width: 200,
        windowWidth: 900,
      });
    } else {
      this.modalService.showErrorMessage(
        `Es necesario rellenar todos los campos obligatorios`
      );
    }
  }
}
